// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-upload-section {
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px; /* Space between sections */
}

.uploaded-info {
    font-size: 20px;
    color: green;
    font-weight: bold;
    padding-left: 10px;
    margin-top: 30px;
}

.loading-message {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 0;
    font-size: 16px;
    color: #555;
}
  
.loading-message .spinner {
    margin-right: 10px;
}

.upload-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 20px;
    padding: 12px 28px;
    border-radius: 6px;
    min-width: 190px;
    background-color: #2f4fb5;
    color: #fff;
    border: none;
    cursor: pointer;
    font-size: 17px;
    font-weight: 600;
    box-shadow: 0 4px 10px rgba(47, 79, 181, 0.25);
    transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.upload-button:hover {
    background-color: #253f92;
    box-shadow: 0 6px 14px rgba(47, 79, 181, 0.3);
    transform: translateY(-1px);
    color: #fff;
}

.upload-button:disabled {
    background-color: #d6dcf5;
    color: #7a86b6;
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
}

/* Style for other loading state */
.file-is-loading {
    display: flex;
    align-items: center;
    margin-top: 10px;
    color: #3498db;
    font-weight: 500;
}

.error-message {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
    padding: 10px;
    margin: 10px 0;
}

/* Upload duration text */
.upload-duration {
    font-size: 16px; /* Smaller than uploaded-info (20px) */
    color: green;
    padding-left: 10px;
    margin-top: 5px;
}

  
`, "",{"version":3,"sources":["webpack://./src/css/step2-uploadFile.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ,EAAE,2BAA2B;AACzC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,8CAA8C;IAC9C,iFAAiF;AACrF;;AAEA;IACI,yBAAyB;IACzB,6CAA6C;IAC7C,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA,kCAAkC;AAClC;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,aAAa;IACb,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,eAAe,EAAE,sCAAsC;IACvD,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB","sourcesContent":[".file-upload-section {\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 5px; /* Space between sections */\n}\n\n.uploaded-info {\n    font-size: 20px;\n    color: green;\n    font-weight: bold;\n    padding-left: 10px;\n    margin-top: 30px;\n}\n\n.loading-message {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 10px 0;\n    font-size: 16px;\n    color: #555;\n}\n  \n.loading-message .spinner {\n    margin-right: 10px;\n}\n\n.upload-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    margin-top: 20px;\n    padding: 12px 28px;\n    border-radius: 6px;\n    min-width: 190px;\n    background-color: #2f4fb5;\n    color: #fff;\n    border: none;\n    cursor: pointer;\n    font-size: 17px;\n    font-weight: 600;\n    box-shadow: 0 4px 10px rgba(47, 79, 181, 0.25);\n    transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;\n}\n\n.upload-button:hover {\n    background-color: #253f92;\n    box-shadow: 0 6px 14px rgba(47, 79, 181, 0.3);\n    transform: translateY(-1px);\n    color: #fff;\n}\n\n.upload-button:disabled {\n    background-color: #d6dcf5;\n    color: #7a86b6;\n    cursor: not-allowed;\n    box-shadow: none;\n    transform: none;\n}\n\n/* Style for other loading state */\n.file-is-loading {\n    display: flex;\n    align-items: center;\n    margin-top: 10px;\n    color: #3498db;\n    font-weight: 500;\n}\n\n.error-message {\n    color: #721c24;\n    background-color: #f8d7da;\n    border-color: #f5c6cb;\n    padding: 10px;\n    margin: 10px 0;\n}\n\n/* Upload duration text */\n.upload-duration {\n    font-size: 16px; /* Smaller than uploaded-info (20px) */\n    color: green;\n    padding-left: 10px;\n    margin-top: 5px;\n}\n\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
